import rulesService from '../../../services/rules-service'
import campaignService from '../../../services/campaigns-service'
import offerConfigService from '../../../services/offer-config-service'
import _ from 'lodash'
import userService from '../../../services/user-service'
import tenantService from '../../../services/tenant-service'
import directOfferService from '../../../services/direct-offer-service'

const RULE_CREATED = 'RULE_CREATED'
const RULE_CREATE_STARTED = 'RULE_CREATE_STARTED'
const RULE_CREATE_ERROR = 'RULE_CREATE_ERROR'

const CAMPAIGN_CREATED = 'CAMPAIGN_CREATED'
const CAMPAIGN_CREATE_STARTED = 'CAMPAIGN_CREATE_STARTED'
const CAMPAIGN_CREATE_ERROR = 'CAMPAIGN_CREATE_ERROR'

const LOAD_OFFER_TAGS = 'LOAD_OFFER_TAGS'

const LOAD_OFFER_DEFINITION_CONFIG_STARTED = 'LOAD_OFFER_DEFINITION_CONFIG_STARTED'
const LOAD_OFFER_DEFINITION_CONFIG_FINISHED = 'LOAD_OFFER_DEFINITION_CONFIG_FINISHED'

const OFFER_UPLOAD_STARTED = 'OFFER_UPLOAD_STARTED'
const OFFER_UPLOAD_FINISHED = 'OFFER_UPLOAD_FINISHED'
const OFFER_UPLOAD_ERROR = 'OFFER_UPLOAD_ERROR'

const TEMPLATE_CONFIG_UPLOAD_STARTED = 'TEMPLATE_CONFIG_UPLOAD_STARTED'
const TEMPLATE_CONFIG_UPLOAD_FINISHED = 'TEMPLATE_CONFIG_UPLOAD_FINISHED'
const TEMPLATE_CONFIG_UPLOAD_ERROR = 'TEMPLATE_CONFIG_UPLOAD_ERROR'

const LOAD_BUSINESS_UNITS_STARTED = 'LOAD_BUSINESS_UNITS_STARTED'
const LOAD_BUSINESS_UNITS_FINISHED = 'LOAD_BUSINESS_UNITS_FINISHED'

export function createRule(ruleInfo) {
  return (dispatch, getState) => {
    dispatch({
      type: RULE_CREATE_STARTED
    })
    return rulesService.createRule(ruleInfo)
      .then((savedRuleInfo) => {
        dispatch({
          type: RULE_CREATED,
          rule: savedRuleInfo
        })
      })
      .catch(err => {
        console.error(err)
        dispatch({
          type: RULE_CREATE_ERROR
        })
      })
  }
}

export function saveAndLaunchCampaign(campaignInfo) {
  return (dispatch, getState) => {
    dispatch({
      type: CAMPAIGN_CREATE_STARTED
    })
    return tenantService.createRequestHandler(campaignInfo.rule.triggers[0])
      .then(createStatus => {
        return campaignService.createCampaign(campaignInfo)
          .then((campaign) => {
            if (_.isEmpty(_.get(campaign, 'errors'))) {
              dispatch({
                type: CAMPAIGN_CREATED,
                campaign: campaign
              })
            } else {
              dispatch({
                type: CAMPAIGN_CREATE_ERROR
              })
            }
          })
      })
  }
}

export function loadOfferTags(businessUnitId) {
  return (dispatch, getState) => {
    return campaignService.getAllOfferTags(businessUnitId)
      .then((offerTags) => {
        dispatch({
          type: LOAD_OFFER_TAGS,
          offerTags: offerTags
        })
      })
  }
}

export function loadOfferDefinitionConfig() {
  return (dispatch, getState) => {
    dispatch({
      type: LOAD_OFFER_DEFINITION_CONFIG_STARTED
    })
    return offerConfigService.getFileImportConfigs()
      .then(fileImportConfigs => {
        const selectedVersion = _.head(
          _.filter(fileImportConfigs, {
            version: {
              name: 'promotionImport'
            }
          })
        )
        let tenantImportConfigId = _.get(selectedVersion, 'id')
        let storeId = _.get(selectedVersion, 'storeId')
        let config = _.get(selectedVersion, 'version.config')
        let configColumns = _.get(JSON.parse(config.toString()), 'columns', {})
        dispatch({
          type: LOAD_OFFER_DEFINITION_CONFIG_FINISHED,
          tenantImportConfigId: tenantImportConfigId,
          storeId: storeId,
          offerDefinitionColumns: configColumns
        })
      })
  }
}

export function uploadOffers(data, storeId, tenantImportConfigId, tenantBrandBusinessId) {
  return (dispatch, getState) => {
    dispatch({
      type: OFFER_UPLOAD_STARTED
    })
    return offerConfigService.uploadOffers(data, storeId, tenantImportConfigId, tenantBrandBusinessId)
      .then(result => {
        dispatch({
          type: OFFER_UPLOAD_FINISHED
        })
      })
  }
}

function transformFieldConfigs(fields) {
  return fields.map(field => {
    if (field.type === 'phone') {
      return {
        type: field.type,
        label: field.data.label,
        validation: {
          isRequired: field.data.isRequired,
          valueLength: {
            min: field.data.minLength,
            max: field.data.maxLength
          }
        }
      }
    } else if (field.type === 'email') {
      return {
        type: field.type,
        label: field.data.label,
        validation: {
          isRequired: field.data.isRequired,
          domains: field.data.domains
        }
      }
    }
  })
}

function makeConfigObject(title, description, fields) {
  return {
    pageTitle: title,
    pageDescription: description,
    fieldConfigs: transformFieldConfigs(fields)
  }
}

export function uploadTemplateConfigAndGetPwaUrl(tenantId, businessUnitId, offerName, title, description, fields) {
  return (dispatch, getState) => {
    dispatch({
      type: TEMPLATE_CONFIG_UPLOAD_STARTED
    })
    const pageConfig = makeConfigObject(title, description, fields)
    return directOfferService.uploadTemplateConfigAndGetPwaUrl(tenantId, businessUnitId, offerName, pageConfig)
      .then(result => {
        dispatch({
          type: TEMPLATE_CONFIG_UPLOAD_FINISHED,
          pwaUrl: result.url
        })
      })
      .catch(err => {
        dispatch({
          type: TEMPLATE_CONFIG_UPLOAD_ERROR,
          error: err
        })
      })
  }
}

export function loadBusinessUnits() {
  return (dispatch, getState) => {
    dispatch({
      type: LOAD_BUSINESS_UNITS_STARTED
    })
    return userService.getCurrentUser().then((userDetails) => {
      let brands = _.get(userDetails, 'tenant.brands')
      let businesses = _.flatMap(_.map(brands, (d) => d.businesses))
      let businessUnits = _.map(businesses, (d) => ({name: d.name, id: d.id}))
      dispatch({
        type: LOAD_BUSINESS_UNITS_FINISHED,
        businessUnits: businessUnits
      })
    })
  }
}

// REDUCERS

export function createRuleReducer(state = {}, action) {
  switch (action.type) {
    case RULE_CREATE_STARTED: {
      return {loading: true, error: false}
    }
    case RULE_CREATED: {
      return {loading: false, rule: action.rule, error: false}
    }
    case RULE_CREATE_ERROR: {
      return {loading: false, error: true}
    }
    default:
      return state
  }
}

export function campaignSaveStatusReducer(state = {}, action) {
  switch (action.type) {
    case CAMPAIGN_CREATE_STARTED: {
      return {loading: true, error: false}
    }
    case CAMPAIGN_CREATED: {
      return {loading: false, success: true, error: false}
    }
    case CAMPAIGN_CREATE_ERROR: {
      return {loading: false, success: false, error: true}
    }
    default:
      return state
  }
}

export function offerTagsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_OFFER_TAGS: {
      return action.offerTags
    }
    default:
      return state
  }
}

export function offerDefinitionConfigReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_OFFER_DEFINITION_CONFIG_STARTED: {
      return {
        loading: true
      }
    }
    case LOAD_OFFER_DEFINITION_CONFIG_FINISHED: {
      return {
        loading: false,
        tenantImportConfigId: action.tenantImportConfigId,
        storeId: action.storeId,
        offerDefinitionColumns: action.offerDefinitionColumns
      }
    }
    default:
      return state
  }
}

export function offerUploadStatusReducer(state = {}, action) {
  switch (action.type) {
    case OFFER_UPLOAD_STARTED: {
      return { loading: true, error: false }
    }
    case OFFER_UPLOAD_FINISHED: {
      return { success: true, loading: false, error: false }
    }
    case OFFER_UPLOAD_ERROR: {
      return { success: false, loading: false, error: true }
    }
    default:
      return state
  }
}

export function templateUploadStatusReducer(state = {}, action) {
  switch (action.type) {
    case TEMPLATE_CONFIG_UPLOAD_STARTED: {
      return { loading: true, error: false }
    }
    case TEMPLATE_CONFIG_UPLOAD_FINISHED: {
      return { loading: false, success: true, pwaUrl: action.pwaUrl, error: false }
    }
    case TEMPLATE_CONFIG_UPLOAD_ERROR: {
      return { loading: false, success: false, error: true }
    }
    default:
      return state
  }
}

export function businessUnitsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_BUSINESS_UNITS_STARTED: {
      return {
        loading: true
      }
    }
    case LOAD_BUSINESS_UNITS_FINISHED: {
      return {
        loading: false,
        businessUnits: action.businessUnits
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/B2BOfferModule/modules/B2BOfferModule.js